(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-main-collection-product-grid"]) return;
  try {
    
  const TD_COLLECTION_GRID_SCRIPT_URLS = window.TD_COLLECTION_GRID_SCRIPT_URLS || {};

  const TD_COLLECTION_LOAD_MORE_SELECTORS = {
    collectionRoot: '[data-td-collection-grid-root]',
    grid: '[data-td-product-grid]',
    label: '[data-td-load-more-label]',
    link: '[data-td-load-more-link]',
    status: '[data-td-load-more-status]',
  };

  function loadTDCollectionGridScript(src) {
    if (!src) return Promise.resolve();

    const escapedSrc = CSS.escape(src);
    const existingScript = document.querySelector(`script[src="${escapedSrc}"]`);

    if (existingScript) {
      if (existingScript.dataset.tdLoaded === 'true' || existingScript.readyState === 'complete') {
        return Promise.resolve();
      }

      return new Promise((resolve, reject) => {
        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', reject, { once: true });
      });
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');

      script.src = src;
      script.defer = true;
      script.async = false;
      script.dataset.tdLoaded = 'false';
      script.addEventListener(
        'load',
        () => {
          script.dataset.tdLoaded = 'true';
          resolve();
        },
        { once: true }
      );
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
  }

  function loadTDCollectionGridScripts() {
    document.querySelectorAll(TD_COLLECTION_LOAD_MORE_SELECTORS.collectionRoot).forEach((collectionGrid) => {
      if (collectionGrid.dataset.tdHasFacets === 'true') {
        loadTDCollectionGridScript(TD_COLLECTION_GRID_SCRIPT_URLS.facets);
      }

      if (collectionGrid.dataset.tdQuickAdd === 'standard') {
        TD_COLLECTION_GRID_SCRIPT_URLS.standardQuickAdd.forEach((src) => {
          loadTDCollectionGridScript(src);
        });
      }

      if (collectionGrid.dataset.tdQuickAdd === 'bulk') {
        TD_COLLECTION_GRID_SCRIPT_URLS.bulkQuickAdd.forEach((src) => {
          loadTDCollectionGridScript(src);
        });
      }
    });
  }

  class TdCollectionLoadMore extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.abortController = null;
      this.isLoading = false;
    }

    connectedCallback() {
      this.grid = document.querySelector(TD_COLLECTION_LOAD_MORE_SELECTORS.grid);
      this.link = this.querySelector(TD_COLLECTION_LOAD_MORE_SELECTORS.link);
      this.label = this.querySelector(TD_COLLECTION_LOAD_MORE_SELECTORS.label);
      this.status = this.querySelector(TD_COLLECTION_LOAD_MORE_SELECTORS.status);

      if (!this.grid || !this.link) return;

      this.link.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      if (this.link) {
        this.link.removeEventListener('click', this.handleClick);
      }

      if (this.abortController) {
        this.abortController.abort();
      }
    }

    handleClick(event) {
      if (!this.dataset.tdNextUrl || this.isLoading) return;

      event.preventDefault();
      this.loadNextPage();
    }

    setStatus(message) {
      if (this.status) {
        this.status.textContent = message || '';
      }
    }

    setLoadingState(isLoading) {
      this.isLoading = isLoading;
      this.toggleAttribute('aria-busy', isLoading);

      if (this.grid) {
        this.grid.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      }

      if (this.link) {
        if (isLoading) {
          this.link.setAttribute('aria-disabled', 'true');
          this.link.tabIndex = -1;
        } else {
          this.link.removeAttribute('aria-disabled');
          this.link.removeAttribute('tabindex');
        }
      }

      if (this.label) {
        this.label.textContent = isLoading ? this.dataset.tdLoadingText : this.dataset.tdButtonText;
      }
    }

    buildRequestUrl() {
      const url = new URL(this.dataset.tdNextUrl, window.location.origin);
      url.searchParams.set('section_id', this.dataset.tdSectionId);
      return url;
    }

    async loadNextPage() {
      this.setStatus(this.dataset.tdLoadingText);
      this.setLoadingState(true);

      try {
        this.abortController = new AbortController();
        const response = await fetch(this.buildRequestUrl().toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: this.abortController.signal,
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch next collection page: ${response.status}`);
        }

        const html = await response.text();
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = parsedHTML.querySelector(TD_COLLECTION_LOAD_MORE_SELECTORS.grid);
        const nextItems = nextGrid ? Array.from(nextGrid.children) : [];

        if (!nextGrid || nextItems.length === 0) {
          throw new Error('Fetched collection page did not include any products.');
        }

        nextItems.forEach((item) => {
          item.querySelectorAll('.scroll-trigger').forEach((element) => {
            element.classList.add('scroll-trigger--cancel');
          });
          this.grid.appendChild(item);
        });

        const replacement = parsedHTML.querySelector('td-collection-load-more[data-td-load-more-root]');

        if (replacement && replacement.dataset.tdNextUrl) {
          const replacementLink = replacement.querySelector(TD_COLLECTION_LOAD_MORE_SELECTORS.link);
          this.dataset.tdNextUrl = replacement.dataset.tdNextUrl;

          if (replacementLink) {
            this.link.href = replacementLink.href;
          }
        } else {
          this.dataset.tdNextUrl = '';

          if (this.link) {
            this.link.remove();
            this.link = null;
          }
        }

        this.setStatus(this.dataset.tdLoadedText);
      } catch (error) {
        if (error.name === 'AbortError') return;

        this.setStatus(this.dataset.tdErrorText);
        if (this.link) {
          window.location.assign(this.link.href);
        }
      } finally {
        this.abortController = null;
        this.setLoadingState(false);
      }
    }
  }

  if (!customElements.get('td-collection-load-more')) {
    customElements.define('td-collection-load-more', TdCollectionLoadMore);
  }

  loadTDCollectionGridScripts();

  } catch(e) { console.error(e); }
})();
})();
